import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";

let apiUrl = environmentService.apiUrlRatePlan;
let headers = {headers: userService.authHeader()};

export const rateplanService = {
  searchRatePlan,
  createRatePlan,
  EditRatePlan
};

async function searchRatePlan (rateplanSearch) {
  return await postRequestHandler(`${apiUrl}/rateplans`, rateplanSearch, headers);
}

async function createRatePlan(NewRatePlan){

  return await postRequestHandler(`${apiUrl}/rateplans/create`, NewRatePlan, headers);
}
async function EditRatePlan(EditRatePlan){
  return await postRequestHandler(`${apiUrl}/rateplans/update`, EditRatePlan, headers);
}



// WEBPACK FOOTER //
// ./src/utils/services/rateplan/rateplan.service.js